/* This is the EMIS class Enviroment for secondary school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 92px"
        width="800px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td class="row-title" rowspan="2">ភូមិសិក្សា</td>
            <td class="row-title-long" colspan="5">
              ចំនួនបន្ទប់ប្រើប្រាស់សម្រាប់បង្រៀន
            </td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">មានអគ្គីសនី</td>
            <td class="row-data">មានអំពូល</td>
            <td class="row-data">មានកង្ហារ/ម៉ាស៊ីនត្រជាក់</td>
            <td class="row-data">បំពាក់ឧបករណ៍ទំនើប</td>
          </tr>
          <!--Row1-->
          <tr>
            <td class="row-title">មធ្យមសិក្សាបឋមភូមិ</td>
            <td class="row-data">
              <numberinput v-model="low[0].clr_low" class="number" />
            </td>
            <td v-for="(value, col) in low.length" :key="col" class="row-data">
              <numberinput v-model="low[col].dt[0]" class="number" />
            </td>
          </tr>
          <!--Row2-->
          <tr>
            <td class="row-title">មធ្យមសិក្សាទុតិយភូមិ(ចំណេះទូទៅ)</td>
            <td class="row-data">
              <numberinput v-model="upp[0].clr_upp" class="number" />
            </td>
            <td v-for="(value, col) in upp.length" :key="col" class="row-data">
              <numberinput v-model="upp[col].dt[0]" class="number" />
            </td>
          </tr>
          <!--Row3-->
          <!-- <tr v-if="tecOnOff === 3"> -->
          <tr v-if="true">
            <td class="row-title">មធ្យមសិក្សាបច្ចេកទេស</td>
            <td class="row-data">
              <numberinput v-model="tec[0].clr_tec" class="number" />
            </td>
            <td v-for="(value, col) in tec.length" :key="col" class="row-data">
              <numberinput v-model="tec[col].dt[0]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["low", "upp", "tec", "tecOnOff", "title"],
  components: {
    numberinput: NumberInput,
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.row-data {
  width: 150px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-title {
  width: 150px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
.row-title-long {
  width: 600px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>